import { createContext } from "react";

export const QVMContext = createContext({});
export const QVMProvider = QVMContext.Provider;
